export default "__VITE_ASSET__DaQiyXR3__"